export const CheckMark = ({ checkColor }: { checkColor: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M20 6.05347L9 17.0535L4 12.0535" stroke={checkColor} strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const CircleArrowUp = ({ arrowStroke, circleStroke }: { arrowStroke: string, circleStroke: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <g clipPath="url(#clip0_10268_27975)">
        <circle cx="12" cy="12.0535" r="11.5695" transform="rotate(-180 12 12.0535)" stroke={circleStroke} strokeWidth="0.860962" />
        <path d="M7.71484 13.3392L12.0006 9.05352L16.2863 13.3392" stroke={arrowStroke} strokeWidth="1.43494" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_10268_27975">
          <rect width="24" height="24" fill="white" transform="translate(24 24.0535) rotate(-180)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CircleArrowDown = ({ arrowStroke, circleStroke }: { arrowStroke: string, circleStroke: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <g clipPath="url(#clip0_10268_27982)">
        <circle cx="12" cy="12" r="11.5695" stroke={circleStroke} strokeWidth="0.860962" />
        <path d="M7.71484 10.7677L12.0006 15.0534L16.2863 10.7677" stroke={arrowStroke} strokeWidth="1.43494" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_10268_27982">
          <rect width="24" height="24" fill="white" transform="translate(0 0.0534668)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const BigX = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M24 8.00003L8 24" stroke="#FF5853" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 8.00003L24 24" stroke="#FF5853" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const ArrowDir = (arrowStroke: string, circleStroke: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_10268_28003)">
        <circle cx="12" cy="12" r="11.5695" transform="rotate(180 12 12)" stroke={circleStroke} strokeWidth="0.860962" />
        <path d="M16.2852 13.2858L11.9994 9.00005L7.71373 13.2858" stroke={arrowStroke} strokeWidth="1.43494" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_10268_28003">
          <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 -1 24 24)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const RightArrow = ({ arrowStroke = '#fff' }: { arrowStroke?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M5 12H19" stroke={arrowStroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 5L19 12L12 19" stroke={arrowStroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const OmniChannel = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M14.6673 7.99902H10.6673L9.33399 9.99902H6.66732L5.33399 7.99902H1.33398" stroke="#001B38" strokeWidth="1.43884" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.63398 3.40602L1.33398 7.99935V11.9994C1.33398 12.353 1.47446 12.6921 1.72451 12.9422C1.97456 13.1922 2.3137 13.3327 2.66732 13.3327H13.334C13.6876 13.3327 14.0267 13.1922 14.2768 12.9422C14.5268 12.6921 14.6673 12.353 14.6673 11.9994V7.99935L12.3673 3.40602C12.2569 3.18387 12.0868 2.99693 11.876 2.8662C11.6651 2.73547 11.422 2.66615 11.174 2.66602H4.82732C4.57926 2.66615 4.33616 2.73547 4.12535 2.8662C3.91454 2.99693 3.74437 3.18387 3.63398 3.40602Z" stroke="#001B38" strokeWidth="1.43884" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const Collaboration = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_10507_135050)">
        <path d="M11.3327 14V12.6667C11.3327 11.9594 11.0517 11.2811 10.5516 10.781C10.0515 10.281 9.37326 10 8.66602 10H3.33268C2.62544 10 1.94716 10.281 1.44706 10.781C0.946967 11.2811 0.666016 11.9594 0.666016 12.6667V14" stroke="#001B38" strokeWidth="1.43884" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.00065 7.33333C7.47341 7.33333 8.66732 6.13943 8.66732 4.66667C8.66732 3.19391 7.47341 2 6.00065 2C4.52789 2 3.33398 3.19391 3.33398 4.66667C3.33398 6.13943 4.52789 7.33333 6.00065 7.33333Z" stroke="#001B38" strokeWidth="1.43884" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.333 13.9993V12.6659C15.3326 12.0751 15.1359 11.5011 14.7739 11.0341C14.4119 10.5672 13.9051 10.2336 13.333 10.0859" stroke="#001B38" strokeWidth="1.43884" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.667 2.08691C11.2406 2.23378 11.749 2.56738 12.1121 3.03512C12.4752 3.50286 12.6722 4.07813 12.6722 4.67025C12.6722 5.26236 12.4752 5.83763 12.1121 6.30537C11.749 6.77311 11.2406 7.10671 10.667 7.25358" stroke="#001B38" strokeWidth="1.43884" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_10507_135050">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Solve = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8.66667 1.33276L2 9.33277H8L7.33333 14.6661L14 6.6661H8L8.66667 1.33276Z" stroke="#001B38" strokeWidth="1.27355" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const Agent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <g clipPath="url(#clip0_188_8223)">
        <path d="M11.4727 14.0002V12.6669C11.4727 11.9597 11.1917 11.2814 10.6916 10.7813C10.1915 10.2812 9.51324 10.0002 8.80599 10.0002H4.13932C3.43208 10.0002 2.7538 10.2812 2.25371 10.7813C1.75361 11.2814 1.47266 11.9597 1.47266 12.6669V14.0002" stroke="#001B38" strokeWidth="1.334" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.47331 7.33333C7.94607 7.33333 9.13998 6.13943 9.13998 4.66667C9.13998 3.19391 7.94607 2 6.47331 2C5.00055 2 3.80664 3.19391 3.80664 4.66667C3.80664 6.13943 5.00055 7.33333 6.47331 7.33333Z" stroke="#001B38" strokeWidth="1.334" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.1406 7.33309L13.474 8.66642L16.1406 5.99976" stroke="#001B38" strokeWidth="1.334" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_188_8223">
          <rect width="16" height="16" fill="white" transform="translate(0.806641)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CustomerSupport = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_188_8229)">
        <path d="M8.00065 14.6666C11.6826 14.6666 14.6673 11.6818 14.6673 7.99992C14.6673 4.31802 11.6826 1.33325 8.00065 1.33325C4.31875 1.33325 1.33398 4.31802 1.33398 7.99992C1.33398 11.6818 4.31875 14.6666 8.00065 14.6666Z" stroke="#001B38" strokeWidth="1.41196" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.33398 9.3335C5.33398 9.3335 6.33398 10.6668 8.00065 10.6668C9.66732 10.6668 10.6673 9.3335 10.6673 9.3335" stroke="#001B38" strokeWidth="1.41196" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 6.00024H6.00617" stroke="#001B38" strokeWidth="1.41196" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 6.00024H10.0062" stroke="#001B38" strokeWidth="1.41196" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_188_8229">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ArrowChart = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
      <g clipPath="url(#clip0_188_8521)">
        <path d="M15.3971 4.10254L9.0638 10.4359L5.73047 7.10254L0.730469 12.1025" stroke="#001B38" strokeWidth="1.31705" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.3945 4.10254H15.3945V8.10254" stroke="#001B38" strokeWidth="1.31705" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_188_8521">
          <rect width="16" height="16" fill="white" transform="translate(0.0625 0.102539)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LineGraph = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <g clipPath="url(#clip0_188_8533)">
        <path d="M15.4408 8H12.7741L10.7741 14L6.77409 2L4.77409 8H2.10742" stroke="#001B38" strokeWidth="1.35321" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_188_8533">
          <rect width="16" height="16" fill="white" transform="translate(0.773438)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ChatBubble = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M14.459 10C14.459 10.3536 14.3185 10.6928 14.0685 10.9428C13.8184 11.1929 13.4793 11.3333 13.1257 11.3333H5.12565L2.45898 14V3.33333C2.45898 2.97971 2.59946 2.64057 2.84951 2.39052C3.09956 2.14048 3.4387 2 3.79232 2H13.1257C13.4793 2 13.8184 2.14048 14.0685 2.39052C14.3185 2.64057 14.459 2.97971 14.459 3.33333V10Z" stroke="#001B38" strokeWidth="1.30946" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const Customize = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_195_15695)">
        <path d="M2.66797 14.0002V9.3335" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.66797 6.66667V2" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 14V8" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 5.33333V2" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.334 14.0003V10.667" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.334 8V2" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.666016 9.3335H4.66602" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 5.33301H10" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.334 10.667H15.334" stroke="#001B38" strokeWidth="1.39913" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  )
}

export const Magnify = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M7.33333 12.6662C10.2789 12.6662 12.6667 10.2784 12.6667 7.33285C12.6667 4.38733 10.2789 1.99951 7.33333 1.99951C4.38782 1.99951 2 4.38733 2 7.33285C2 10.2784 4.38782 12.6662 7.33333 12.6662Z" stroke="#001B38" strokeWidth="1.462" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.9996 14.0001L11.0996 11.1001" stroke="#001B38" strokeWidth="1.462" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.33203 5.33301V9.33301" stroke="#001B38" strokeWidth="1.462" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.33398 7.33301H9.33398" stroke="#001B38" strokeWidth="1.462" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const Track = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_195_15669)">
        <path d="M8.00065 14.6663C11.6826 14.6663 14.6673 11.6816 14.6673 7.99968C14.6673 4.31778 11.6826 1.33301 8.00065 1.33301C4.31875 1.33301 1.33398 4.31778 1.33398 7.99968C1.33398 11.6816 4.31875 14.6663 8.00065 14.6663Z" stroke="#001B38" strokeWidth="1.30309" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z" stroke="#001B38" strokeWidth="1.30309" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.99935 9.33366C8.73573 9.33366 9.33268 8.73671 9.33268 8.00033C9.33268 7.26395 8.73573 6.66699 7.99935 6.66699C7.26297 6.66699 6.66602 7.26395 6.66602 8.00033C6.66602 8.73671 7.26297 9.33366 7.99935 9.33366Z" stroke="#001B38" strokeWidth="1.30309" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_195_15669">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Plus = ({ strokeColor = 'stroke-white' }: { strokeColor?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7.00024 2.91675V11.0834" className={strokeColor} strokeWidth="1.48758" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.91675 7H11.0834" className={strokeColor} strokeWidth="1.48758" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const PlusCircle = (strokeColor: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M15.9993 29.3337C23.3631 29.3337 29.3327 23.3641 29.3327 16.0003C29.3327 8.63653 23.3631 2.66699 15.9993 2.66699C8.63555 2.66699 2.66602 8.63653 2.66602 16.0003C2.66602 23.3641 8.63555 29.3337 15.9993 29.3337Z" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 10.667V21.3337" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.666 16H21.3327" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const MinusCircle = (strokeColor: string) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M15.9993 29.3337C23.3631 29.3337 29.3327 23.3641 29.3327 16.0003C29.3327 8.63653 23.3631 2.66699 15.9993 2.66699C8.63555 2.66699 2.66602 8.63653 2.66602 16.0003C2.66602 23.3641 8.63555 29.3337 15.9993 29.3337Z" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.668 16H21.3346" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
